import { pxToRem } from '../../../utils';
import { HEADER_VAR } from '../../organisms/HeaderV2/HeaderV2.variables';
export var SLIDERCARD = {
  bgColor: {
    "private": '--_nva-slidercard--bg-color',
    "public": '--nva-slidercard--bg-color',
    value: 'hsl(var(--g-color-neutral-900))',
    transparent: 'transparent' // for parallax
  },

  textColor: {
    "private": '--_nva-slidercard--text-color',
    "public": '--nva-slidercard--text-color',
    light: 'hsl(var(--g-color-light))',
    dark: 'hsl(var(--g-color-dark))'
  },
  contrast: {
    "private": '--_nva-slidercard--contrast',
    "public": '--nva-slidercard--contrast',
    light: 'var(--g-color-white)',
    dark: 'var(--g-color-black)'
  },
  contrastOpacity: {
    "private": '--_nva-slidercard--contrast-opacity',
    "public": '--nva-slidercard--contrast-opacity',
    edgeDark: '0.8',
    edgeLight: '0.4',
    centerDark: '0.5',
    centerLight: '0.3'
  },
  minHeight: {
    "private": '--_nva-slidercard--min-height',
    "public": '--nva-slidercard--min-height',
    value: "min(70vh, ".concat(pxToRem(1200), ")")
  },
  bgImagePosition: {
    "private": '--_nva-slidercard--bg-image-position',
    "public": '--nva-slidercard--bg-image-position',
    value: '50% 50%'
  },
  columnStart: {
    "private": '--_nva-slidercard--column-start',
    "public": '--nva-slidercard--column-start',
    full: '1',
    centerLg: '3',
    rightLg: '7'
  },
  columnEnd: {
    "private": '--_nva-slidercard--column-end',
    "public": '--nva-slidercard--column-end',
    full: '-1',
    leftLg: 'span 6',
    centerLg: 'span 8',
    rightLg: 'span 6'
  },
  paddingOnHeaderOverlay: {
    "private": '--_nva-slidercard--padding-on-header-overlay',
    "public": '--nva-slidercard--padding-on-header-overlay',
    mobileSplit: '0px',
    mobileFull: 'calc(32px + 4.875rem)',
    // by default, no padding on mobile
    lg: 'calc(32px + 9.875rem)',
    //Magic number approximate size of generic headers, rems due to text
    '3xl': 'calc(32px + 7.375rem)',
    value: "calc((var(--l-padding-block)*2) + var(".concat(HEADER_VAR.height["public"], "))")
  }
};